import React, { useContext, useEffect } from "react";
import { StoreContext } from "../store/Store";
import { Spaces } from "./Spaces";
import { Customers } from "./Customers";
import { Bookings } from "./Bookings";
import { Availability } from "./Availability";
import { Reports } from "./Reports";
import { Approvals } from "./Approvals";
import { Config } from "./Config";
import { TabButtons } from "../components/TabButtons";
import { GlobalRefContext } from "../store/GlobalRefs";
import { actionTypes } from "../store/storeTypes";
import {
  getDynamoDBConfig,
  listSpace,
  listBooking,
  listCustomer,
} from "../api/api";
import { applyOverrides } from "../components/utils";

const list = [
  "Spaces",
  "Customers",
  "Bookings",
  "Availability",
  "Reports",
  "Config",
  "Approvals",
];

export const Admin = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { identity, selected, auth, loggedIn, trace } = store;

  if (trace) console.log("Admin", loggedIn, identity);

  const grefs = useContext(GlobalRefContext);

  useEffect(() => {
    if (loggedIn.status) {
      const asyncFunction = async () => {
        const resConfig = await getDynamoDBConfig(auth, identity.site);
        const defConfig = await getDynamoDBConfig(auth, "default");

        if (resConfig.statusCode === 200 && defConfig.statusCode === 200) {
          const payload = applyOverrides(
            defConfig.body.Item,
            resConfig.body.Item ? resConfig.body.Item : {}
          );

          //save arrays
          dispatch({
            type: actionTypes.SET_CONFIG,
            payload: payload,
          });
        }
        const resSpaces = await listSpace(auth, identity.site);
        if (resSpaces.statusCode === 200) {
          const body = JSON.parse(resSpaces.body);

          dispatch({
            type: actionTypes.SET_SPACES,
            payload: body.spaces,
          });
        } else {
          alert("errorMessage" in resSpaces ? resSpaces.errorMessage : "Error");
        }
        const resCustomers = await listCustomer(auth, identity.site);
        if (resCustomers.statusCode === 200) {
          const body = JSON.parse(resCustomers.body);
          dispatch({
            type: actionTypes.SET_CUSTOMERS,
            payload: body.customers,
          });
        }
        const resBookings = await listBooking(auth, identity.site);

        if (resBookings.statusCode === 200) {
          const bookings = JSON.parse(resBookings.body).bookings;
          grefs.bookings.current = bookings;
          dispatch({
            type: actionTypes.SET_BOOKINGS_LOADED,
            payload: true,
          });
        } else {
          alert(
            "errorMessage" in resBookings ? resBookings.errorMessage : "Error"
          );
        }
      };
      asyncFunction();
    }
  }, [auth, dispatch, identity, grefs, loggedIn]);

  return loggedIn.status && auth ? (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TabButtons list={list} />
      <div
        style={{
          width: "100%",
          flexGrow: 1,
          flexShrink: 0,
          flexBasis: "auto",
        }}
      >
        {selected === "Spaces" && <Spaces />}
        {selected === "Customers" && <Customers />}
        {selected === "Bookings" && <Bookings />}
        {selected === "Availability" && <Availability />}
        {selected === "Reports" && <Reports />}
        {selected === "Config" && <Config />}
        {selected === "Approvals" && <Approvals />}
      </div>
    </div>
  ) : null;
};
